module.exports = __webpack_public_path__ + "static/img/meeting-overview.bff88c22.jpg";